export default __webpack_public_path__ + "media/zurb/img/playground/what-are-ux-metrics-e1edbbb656d978f476e6d4674363cc47.svg";